import axios from 'axios'
import $http from '@/plugins/axios'
import BaseService from '@/services/base.service'
import Cookie from 'js-cookie'
import $const from '@/utils/const'

export const BotService = new BaseService('bots')
BotService.getAll = function (botCode) {
    return $http.get(`bots/${botCode}/all/`)
}
BotService.getDialogAct = function (botCode) {
    return $http.get(`bots/${botCode}/dialog-act/`)
}
BotService.getListBuiltInLuaFunction = async function (botCode, searchOptions) {
    let result = []
    let apiUri = `${process.env.VUE_APP_BASE_API_URL}/bot/${botCode}/lua-function/list?`
    if (searchOptions.name) {
        apiUri = apiUri + '&name=' + searchOptions.name
    }
    if (searchOptions.page) {
        apiUri = apiUri + '&page=' + searchOptions.page
    }
    if (searchOptions.pageSize) {
        apiUri = apiUri + '&pagesize=' + searchOptions.pageSize
    }
    await $http.get(apiUri)
        .then(response => {
            result = response.data
        }).catch(err => {
            console.log(err)
            result = {}
        })
    return result
}
BotService.testLuaFunction = async function (botCode, script, config) {
    let res = null
    let apiUri = `${process.env.VUE_APP_BASE_API_URL}/bot/${botCode}/lua-function/test/${config.id}`
    if (script === '') {
        res = 'noScript'
    } else {
        await $http.post(apiUri, {
            script: script,
            name: config.name
        }).then(response => {
            res = response.data.output
        }).catch(e => {
            res = e.response.data.output
        })
    }
    return res
}
export const ScenarioService = new BaseService('bots', 'scenarios')
export const ConstantService = new BaseService('bots', 'dm_memories')
export const WebViewService = new BaseService('bots', 'dm_webviews')
export const TagService = new BaseService('bots', 'tags')
export const CrmService = new BaseService('bots', 'crm')
export const SuggestionService = new BaseService('bots', 'intent_for_suggestion')
export const VariableService = new BaseService('bots', 'scenarios', 'scenario_memories')
export const StepService = new BaseService('bots', 'scenarios', 'steps')
export const StepConfigService = new BaseService('bots', 'scenarios', 'steps', 'step_configs')
export const CardService = new BaseService('bots', 'scenarios', 'steps', 'cards')

ScenarioService.updatePosition = function (botCode, scenarioCodeList) {
    return $http.put(`bots/${botCode}/scenarios/re_order_scenario_position/`, {
        list_scenario_code: scenarioCodeList
    })
}

ScenarioService.updateReminder = function (botCode, time) {
    return axios.put(
        `${process.env.VUE_APP_BASE_API_URL}/bot/${botCode}/dm_scenario/update_expired_session_time/`, {
            config_time_expired: time
        }, {
            headers: {
                Authorization: `Bearer ${Cookie.get($const.TOKEN_KEY)}`
            }
        }
    )
}

ScenarioService.getRequestSupportCategory = function (botCode) {
    return $http.get(
        `/bots/${botCode}/request_support_categories/`
    )
}

StepService.updatePosition = function (botCode, targetScenarioCode, stepCode, stepCodeList) {
    return $http.put(`bots/${botCode}/scenarios/move_order_scenario_step/`, {
        step_code: stepCode,
        target_scenario_code: targetScenarioCode,
        list_step_code: stepCodeList
    })
}

CardService.updatePosition = function (botCode, scenarioCode, stepCode, cardCodeList) {
    return $http.put(`bots/${botCode}/scenarios/${scenarioCode}/steps/${stepCode}/re_order_list_card/`, {
        list_card_code: cardCodeList
    })
}

CardService.uploadImage = function (botCode, file) {
    let formData = new FormData()
    formData.append('image', file)
    return $http.post(`bots/${botCode}/upload_image/`, formData)
}

TagService.getTagWithStepInfo = function (botCode) {
    return $http.get(`bots/${botCode}/tags/get_tags_with_step_info/`)
}

export const NlpService = {
    getIntentSample (botCode, intentLabel) {
        return $http.get(`bots/${botCode}/nlp/get_dm_sample_by_intent/${intentLabel}/`)
    }
}

export default BotService
